/**
 * Dev-bypass helper — для локального деплоя Janni Kremm.
 *
 * В ENV (frontend) задан VITE_DEV_AUTH_BYPASS_TOKEN. Этот же токен задан в backend ENV.
 * Клиент шлёт X-Dev-Bypass-Token → backend выдаёт JWT для суперадмина.
 *
 * Используется в:
 * - main.tsx (при старте — попытка авто-логина)
 * - /login страница (кнопка "Войти как суперадмин")
 */
import api from '@/lib/api';
import { useAuthStore } from '@/store/authStore';
import type { Account } from '@/hooks/useAccount';

export interface DevBypassAccount extends Account {}

interface DevBypassResponse {
  access_token: string;
  refresh_token: string;
  token_type: 'bearer';
  account: DevBypassAccount;
}

export function isDevBypassEnabled(): boolean {
  return !!import.meta.env.VITE_DEV_AUTH_BYPASS_TOKEN;
}

export async function devBypassLogin(): Promise<Account | null> {
  if (!isDevBypassEnabled()) return null;

  const token = import.meta.env.VITE_DEV_AUTH_BYPASS_TOKEN as string;

  try {
    // Кладём токен в header на время запроса
    const response = await api.post<DevBypassResponse>(
      '/auth/dev-bypass',
      {},
      { headers: { 'X-Dev-Bypass-Token': token } },
    );
    const { access_token, account } = response.data;
    useAuthStore.getState().setAuth(account, access_token);
    return account;
  } catch (e) {
    console.error('dev-bypass login failed:', e);
    return null;
  }
}
